import { AxiosPublic } from '../config/axios';
import { createContext, useEffect, useState, } from 'react';


export const GlobalDataContext = createContext()

const GlobalDataProvider = ({ children }) => {
    const [state, setState] = useState({})
    useEffect(() => {
        const get = async () => {
            await AxiosPublic.get('contact')
                .then(res => setState(res.data.data))
                .catch(err => alert(err.response?.data.message || 'مشکلی رخ داده است'))
        }
        get()
    }, [])
    
    return (
        <>
            <GlobalDataContext.Provider value={{ state }}>
                {children}
            </GlobalDataContext.Provider>
        </>
    );
};

export default GlobalDataProvider;
